/**
 * Get the subdomain extracted by nginx from the Host header.
 * Returns null if not on a subdomain (e.g., noma.to, localhost).
 */
export function getSubdomain(): string | null {
  if (typeof window === "undefined") return null;

  const subdomain = window.__NOMA_SUBDOMAIN__;
  return subdomain && subdomain.length > 0 ? subdomain : null;
}
